import React from 'react';
import {Card, Grid} from 'semantic-ui-react';

const PointOfContactCardDetails = ({contact, displayPhoneNumber}) => {
  return contact && displayPhoneNumber ? (
    <Card fluid className="poc-card">
      <Grid celled="internally" fluid>
        <Grid.Column width={4}>
          <div>
            <strong>
              {contact.firstName} {contact.middleInitial} {contact.lastName}
            </strong>
          </div>
          <div>
            <span className="left-box">
              {contact.title}
              <br />
              {contact.electronicPoc}
            </span>
          </div>
        </Grid.Column>
        <Grid.Column width={10}>
          <Grid columns={4}>
            <Grid.Column width="8">
              <div>
                <strong className="pocInfo">Mailing address</strong>
              </div>
              {contact.address && (
                <div className="contact-address">
                  {contact.address.addressLine1} <br />
                  {contact.address.addressLine2}
                  {contact.address.addressLine2 ? <br /> : ''}
                  <span className="org-city">
                    {contact.address.city ? `${contact.address.city}, ` : null}
                  </span>
                  {contact.address.state} {contact.address.zip}
                  <span className="org-zip-4">
                    {contact.address.zipPlus4 ? `-${contact.address.zipPlus4}` : null}
                  </span>
                </div>
              )}
              <div>
                <span className="email-output">
                  <div>
                    <strong className="pocInfo">Email</strong>
                  </div>
                  {contact.email}
                </span>
              </div>
            </Grid.Column>
            <Grid.Column width="8">
              <div>
                <strong className="pocInfo">Phone</strong>
              </div>
              {contact.phone &&
                displayPhoneNumber(contact.phone.areaCode, contact.phone.phoneNumber)}
              {contact.phone &&
                contact.phone.phoneExtension &&
                ` ext: ${contact.phone.phoneExtension}`}
              <div>
                <strong className="pocInfo">Fax</strong>
              </div>
              {contact.faxNumber}
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Card>
  ) : (
    'No Contacts.'
  );
};

export default PointOfContactCardDetails;
